import React, { Component } from 'react'

// lib
import { Row } from 'antd'

// sub component
import PageLinkComponent from './page_link_component'

// redux 
import { connect } from 'react-redux' 

// auth 
import { type } from '../../constants/QBActionsConst'
import GetOptions from '../../screens/shared/sidebar/authorization'

const ListPages = [
    {
        id: 'sidebar.user',
        key: 'users',
        url: '/app/users',
        openkey: 'category',
        image: require('../../resource/image/userManager.jpg'),
        allow: [type.USER_VIEW]
    },
    {
        id: 'sidebar.organization',
        key: 'organization-management',
        url: '/app/organization-management',
        openkey: 'category',
        image: require('../../resource/image/orgManager.png'),
        allow: [type.ORGANIZATION_VIEW]
    },
    {
        id: 'sidebar.task',
        key: 'qbtask',
        url: '/app/qbtask',
        openkey: 'category',
        image: require('../../resource/image/TaskManager.png'),
        allow: [type.TASK_VIEW]
    },
    {
        id: 'sidebar.qbobjects',
        key: 'qbobjects',
        url: '/app/qbobjects',
        openkey: 'category',
        image: require('../../resource/image/objectManager.png'),
        allow: [type.OBJECT_VIEW]
    },
    {
        id: 'sidebar.qbevents',
        key: 'qbevents',
        url: '/app/qbevents',
        openkey: 'category',
        image: require('../../resource/image/calendar.jpg'),
        allow: [type.EVENT_VIEW]
    },
    {
        id: 'sidebar.qbmedia',
        key: 'qbmedias',
        url: '/app/qbmedias',
        openkey: 'category',
        image: require('../../resource/image/document.png'),
        allow: [type.MEDIA_VIEW]
    },
    {
        id: 'sidebar.role',
        key: 'qbrole',
        url: '/app/qbrole',
        openkey: 'category',
        image: require('../../resource/image/setting.png'),
        allow: [type.ONLY_SUPER_ADMIN]
    },
    {
        id: 'sidebar.qbreport',
        key: 'qbreport',
        url: '/app/qbreport',
        openkey: 'category',
        image: require('../../resource/image/multitier.png'),
        allow: [type.REPORT_VIEW]
    },
]

class ListPageLinks extends Component {
    render() {
        const { user } = this.props

        let optionAuth = GetOptions(ListPages, user)

        return (
            <div className="ListPageLink">
                <Row>
                    {optionAuth.map((page, index) => {
                        return <PageLinkComponent key={index} page={page} />
                    })}
                </Row>
            </div>
        )
    }
}

const mapStateToProps = state => {
    return {
        user: state.auth.userInfo
    }
}

const mapDispatchToProps = dispatch => {
    return {

    }
}

export default connect(mapStateToProps, mapDispatchToProps)(ListPageLinks)
